import { formatDate } from "@progress/kendo-intl";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import {
  abstract,
  IIndentData,
  IIndentRawData,
  routeabs,
  routeabsheader,
  totalabs,
} from "./mainabstract";
import { useGetPrepareIndent } from "../../apiclient/indent/useGetPrepareIndentApi";
import { Interface } from "readline";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import { useLoadData } from "../../hooks/use-load-data.hook";
import axios from "axios";
import { IndentAbstractRow } from "./indent.abstract.row";
import SingleDropdown from "../../components/CustomDropdown";
import { IndentAbstractHeader } from "./indent.abstract.header";
import Item from "antd/es/list/Item";
import { IndentAbstractDetail } from "./indent.detail.header";
import { IndentTotalAbstract } from "./indent.total.abstract";
import dayjs from "dayjs";
import { RadioButton } from "@progress/kendo-react-inputs";
import "./indent.component.scss"

const IndentPreparation = () => {
  const [data, setData] = useState<IIndentRawData>(null);
  const [dataAbsRouteHeader, setDataRouteHeader] =
    useState<routeabsheader>(null);
  const [routeAbstract, setRouteAbstract] = useState<routeabs[]>([]);
  const [totalAbstract, setTotalAbstract] = useState<totalabs>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const refRouteName = useRef("");
  const [statusList, setStatusList] = useState<any>([
    { text: "Evening", value: "2" },
  ]);
  const refStatus = useRef<string>("");
  const [startDate, setStartDate] = useState<string>(dayjs("2024-01-10").format("YYYY-DD-MM"));
  const [shift, setShift] = useState<number>(1);
  const [selectedDate, setSelectedDate]=useState<String>("today");
  const [noRecord, setNoRecord]=useState<boolean>(false);

  const {
    data: result,
    isLoading: isPreparIndentLoading,
    isError,
    refetch: reload,
  } = useGetPrepareIndent({
    variables: {
      date: startDate,
      shiftId: shift,
    },
  });
  // const loadData = () => {
  //   const statusParameters: any = [];
  //   statusParameters.push({ text: "Morning", value: "1" });
  //   statusParameters.push({ text: "Evening", value: "2" });
  //   setStatusList(statusParameters);
  //   const apiUrl =
  //     "https://localhost:62368/api/TotalAbstract/GetTotalAbstractByDateShift/2024-10-01/1";
  //   axios
  //     .get(apiUrl)
  //     .then((response) => {
  //       setData(response?.data);
  //       setLoading(false);
  //       const objIndentData: IIndentData = JSON.parse(response?.data?.result);
  //       setRouteAbstract(objIndentData?.routeabs);
  //       setTotalAbstract(objIndentData?.totalabs);
  //       console.log(objIndentData.totalabs)

  //     })
  //     .catch((error) => {
  //       setError(error);
  //       setLoading(false);
  //     });
  // };

  //loadData();
  useEffect(() => {
    if (result) {
      if (result?.result) {
        const objIndentData: IIndentData = JSON.parse(result?.result);
        setRouteAbstract(objIndentData?.routeabs);
        setTotalAbstract(objIndentData?.totalabs);
        console.log(objIndentData?.routeabs)
        setNoRecord(objIndentData?.totalabs?.totaldetails!==null? false : true);
      }else{
        setTotalAbstract(null);
        setRouteAbstract(null);
      }
    }
  }, [result,startDate,selectedDate]);
  
  const onDateChange=(type: string)=>{
    
    setSelectedDate(type);
    const date = dayjs(new Date());
    if (type==="today"){
      setStartDate(date.format("YYYY-DD-MM"));
    }else{
      setStartDate(date.add(1,'day').format("YYYY-DD-MM"));
    }
    reload();
  }
  return (
    <>
      <div className="d-flex justify-content-between pt-3 pb-1 row col-10">
        <div className="m-lg-5 mt-lg-3 m-4 row col-10">
          <div className="d-flex justify-content-between pt-3 pb-3">
            <div className="d-flex">
              <div className="me-2 d-flex col-12">
                <div className="col-6 borderd-content">
                  <div className="title">Date</div>
                  <div className="content d-flex mt-4 ms-4">
                    <div className="d-flex">
                      <RadioButton
                        checked = {selectedDate==="today"?true: false}
                        style={{
                          border: "1px solid red",
                          marginTop: "8px",
                          marginRight: "10px",
                        }}
                        name="date"
                        onChange={() => {
                          onDateChange("today");
                        }}
                      >
                        <h4 style={{ marginBottom: "15px" }}>Today</h4>
                      </RadioButton>
                    </div>
                    <div className="col-3 d-flex">
                      <RadioButton
                       checked = {selectedDate!=="today"?true: false}
                        style={{
                          border: "1px solid red",
                          marginLeft: "35px",
                          margin: "15px",
                          marginTop: "8px",
                          marginRight: "5px",
                        }}
                        onChange={() => {
                          onDateChange("tomorrow");
                        }}
                        name="date"
                      >
                        <h4 style={{ marginBottom: "15px" }}>Tomorrow</h4>
                      </RadioButton>
                    </div>
                  </div>
                </div>
                <div className="col-6 borderd-content ms-5">
                  <div className="title">Shift</div>
                  <div className="content d-flex mt-4 ms-4">
                    <div className="d-flex">
                      <RadioButton
                        checked = {shift===1?true: false}
                        style={{
                          border: "1px solid red",
                          marginTop: "8px",
                          marginRight: "10px",
                          marginLeft: "45px",
                        }}
                        onChange={() => {
                          setShift(1);  
                          reload()  
                        }}
                        name="shift"
                      >
                        <h4 style={{ marginBottom: "15px" }}>Morning</h4>
                      </RadioButton>
                    </div>
                    <div className="col-3 d-flex">
                      <RadioButton
                      checked = {shift!==1?true: false}
                        style={{
                          border: "1px solid red",
                          marginTop: "8px",
                          marginRight: "5px",
                          marginLeft: "45px",
                        }}
                        onChange={() => {
                          setShift(2);
                          reload()    
                        }}
                        name="shift"
                      >
                        <h4 style={{ marginBottom: "15px" }}>Evening</h4>
                      </RadioButton>
                    </div>
                  </div>
                </div>

                <div className="col-3 ms-5 d-flex">
                  <button
                    className="mt-4 btn-primary btn search-btn"
                    style={{ width: "150px" }}
                    onClick={() => {
                      reload()
                    }}
                    type="submit"
                  >
                    Go
                  </button>
                  <div className="mb-5"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <center>
          <LoadingIndicator
            isLoading={isPreparIndentLoading}
            showLabel={true}
            title="Loading.."
          ></LoadingIndicator>
        </center>
        {noRecord?(
        <div className="row card border-0 sw-shadow radius-10  ms-5  me-5 col-12">
            <div><h4>No detail found for selected date. {dayjs(startDate).format("DD.MM.YYYY")} Shift: {shift===1?"Morning":"Evening"}</h4></div>
        </div>) :(
        <>
        <div className="row card border-0 sw-shadow radius-10  ms-5  me-5 col-12">
          <div className="mt-5">
            <div className="d-flex col-12">
              <div className="col-6">
                <h4>Total Abstract</h4>
              </div>
              <div className="col-6">
                <h4 style={{ float: "right" }}>
                  Date: {dayjs(startDate).format("DD.MM.YYYY")}
                </h4>
              </div>
            </div>
              <IndentTotalAbstract
                totalabstract={totalAbstract}
              ></IndentTotalAbstract>
          </div>
        </div>
        <div className="row card border-0 sw-shadow radius-10  ms-5 me-5 col-12">
          {routeAbstract && routeAbstract?.length > 0 ? (
            <div className="m-2">
              <h4>Route Abstract</h4>
            </div>
          ) : (
            <div></div>
          )}
          <div className="row col-12">
            {routeAbstract &&
              routeAbstract?.map((mainabs) => {
                return (
                  <>
                    {mainabs?.routeabstract?.length > 0 ? (
                      <>
                        <div style={{ margin: "5px" }}>
                          {mainabs?.routedetails[0] !== undefined ? (
                            <>
                              <IndentAbstractDetail
                                routeDetailHeader={mainabs?.routedetails[0]}
                              ></IndentAbstractDetail>
                            </>
                          ) : null}
                          <table
                            className="striped bordered hover"
                            style={{ width: "100%" }}
                            border={1}
                            cellPadding={5}
                            cellSpacing={5}
                          >
                            <thead>
                              <IndentAbstractHeader
                                routeAbstractHeader={
                                  mainabs?.routeabstractheader[0]
                                }
                              ></IndentAbstractHeader>
                            </thead>
                            {mainabs?.routeabstract?.map((item) => {
                              return (
                                <IndentAbstractRow
                                  routeAbstractRow={item}
                                ></IndentAbstractRow>
                              );
                            })}
                          </table>
                          <div style={{float:"right"}} className="mt-2">
                            <div style={{float:"right"}}> <button className="btn-primary btn search-btn">Show Detail</button></div>
                          </div>
                          <br></br>
                        </div>
                      </>
                    ) : null}
                  </>
                );
              })}
          </div>
        </div></>)}
      </div>
    </>
  );
};

export default IndentPreparation;
